import { cn } from "@/lib/client/utils";

export const H1 = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return <h1 className={cn("text-3xl font-bold", className)}>{children}</h1>;
};

export const H2 = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return <h2 className={cn("text-xl font-bold", className)}>{children}</h2>;
};

export const H3 = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return <h3 className={cn("text-lg font-bold", className)}>{children}</h3>;
};
